import React from 'react'
import { useGetQueryData } from '../../../utils/react-query-hooks/general'
import FooterV2 from './FooterV2'



export const Footer = () => {
    const {_Nav, deployment, SELF_MANAGED_BASE_CONFIGS} = useGetQueryData('platformConfigs')
    const {user} = useGetQueryData('userData') || {};

    //if this is self managed and it says not to show footer then dont show
    if(SELF_MANAGED_BASE_CONFIGS?.enable === true && SELF_MANAGED_BASE_CONFIGS?.enableFooter === false){
        return null;
    }

    //else if the deployment configs says to show footer only if user has logged in,
    //and user is not logged in, then dont show.
    if(deployment?._EnableFooterOnlyIfLogged?.enable && !user){
        return null;
    }

    return <FooterV2 config={{_Nav, deployment}}/>

}